import(/* webpackMode: "eager", webpackExports: ["CguSideMenu"] */ "/app/ui/app/(public)/cgu/CguSideMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/ui/app/(public)/cgu/page.module.scss");
